import client from "/src/services/client.js";

export default {
    getBrains: () => client.get("rag/brains"),
    getBrain: (id) => client.get(`rag/brains/${id}`),
    createBrain: (data) => client.post("rag/brains", data),
    deleteBrain: (id) => client.delete(`rag/brains/${id}/subscription`),
    updateBrain: (id, data) => client.put(`rag/brains/${id}`, data),
    getModels: () => client.get("rag/models"),
};
